import React from "react";
import { Formik, Form } from "formik";
import l from "components/util/l";
import CollectionPermissionField from "components/util/helpers/CollectionPermissionField";

const PermissionFormView = ({
  flowId,
  collectionSettings = {},
  isLoading = false,
  onSubmit
}) => {
  return <div className="card">

    <div className="card-header">
      <div className="d-flex justify-content-between align-items-center w-100">
        <h3 class="mb-0">
          {l("Permisos%GA080")}
        </h3>
      </div>
    </div>

    <div className="card-body px-4">
      <Formik
        initialValues={collectionSettings}
        onSubmit={onSubmit}>
        {({ values, setFieldValue }) =>
          <Form>

            <CollectionPermissionField
              flowId={flowId}
              values={values}
              setFieldValue={setFieldValue}
            />

            <button
              type="submit"
              class="btn btn-block btn-primary mt-3"
              disabled={isLoading}
            >
              {
                isLoading &&
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
              }
              {
                !isLoading && <>
                  {l("Guardar%GA023")}
                </>
              }
            </button>

          </Form>
        }
      </Formik>
    </div>

  </div>;
}

export default PermissionFormView;